/**
 * AI seat helpers for the UI. Keep the levels in sync with server/src/services/aiSeats.ts.
 */

export type AiDifficultyLevel = 'low' | 'medium' | 'high';

export const AI_DIFFICULTY_LEVELS: AiDifficultyLevel[] = ['low', 'medium', 'high'];

/** The engine's 0–1 difficulty each named level maps to. */
export const AI_DIFFICULTY: Record<AiDifficultyLevel, number> = {
  low: 0.2,
  medium: 0.5,
  high: 0.85,
};

export const AI_DIFFICULTY_LABEL: Record<AiDifficultyLevel, string> = {
  low: 'Easy',
  medium: 'Medium',
  high: 'Hard',
};

/** Nearest named level for a stored difficulty. */
export function aiDifficultyLevelFor(difficulty: number | undefined): AiDifficultyLevel {
  const d = difficulty ?? AI_DIFFICULTY.high;
  let best: AiDifficultyLevel = 'medium';
  let bestDist = Infinity;
  for (const level of AI_DIFFICULTY_LEVELS) {
    const dist = Math.abs(AI_DIFFICULTY[level] - d);
    if (dist < bestDist) {
      bestDist = dist;
      best = level;
    }
  }
  return best;
}

export function aiDifficultyLabel(difficulty: number | undefined): string {
  return AI_DIFFICULTY_LABEL[aiDifficultyLevelFor(difficulty)];
}

export function isAiPlayer(player: { ai?: unknown } | undefined | null): boolean {
  return !!player?.ai;
}
